import SmimeViewState from '../store/schema/SmimeViewState';
import SmimeType from 'owa-mail-store/lib/store/schema/SmimeType';

export default function createSmimeDefaultViewState(smimeType?: SmimeType): SmimeViewState {
    let shouldEncryptMessageAsSmime = false;
    let shouldSignMessageAsSmime = false;

    switch (smimeType) {
        case SmimeType.Encrypted:
            shouldEncryptMessageAsSmime = true;
            shouldSignMessageAsSmime = false;
            break;
        case SmimeType.OpaqueSigned:
        case SmimeType.ClearSigned:
            shouldEncryptMessageAsSmime = false;
            shouldSignMessageAsSmime = true;
            break;
        case SmimeType.SignedThenEncrypted:
        case SmimeType.EncryptedThenSigned:
        case SmimeType.TripleWrapped:
            shouldEncryptMessageAsSmime = true;
            shouldSignMessageAsSmime = true;
            break;
        case SmimeType.Unknown:
        case SmimeType.None:
        default:
            shouldEncryptMessageAsSmime = false;
            shouldSignMessageAsSmime = false;
    }

    return {
        shouldEncryptMessageAsSmime,
        shouldSignMessageAsSmime,
    } as SmimeViewState;
}
